;
(function ($) {
  var dataKey = 'app.instalmentNavigator';
  var InstalmentNavigator = function InstalmentNavigator(element, options) {
    this.element = element;
    this.init(options);
  };
  InstalmentNavigator.prototype = {
    instalmentTable: null,
    attr: {
      pluginContainer: 'data-instalmentnavigator',
      pageIndex: 'data-instalmentnavigator-page'
    },
    classes: {
      hidden: 'hidden',
      instalmentTableHidden: 't-hidden',
      instalmentTablePageNumberActive: 'page--active',
      instalmentTables: 'plandetails__instalments',
      active: 'active'
    },
    partialIds: {
      pageInstalmentsFirstPartial: '#page-instalments-',
      pageNumberPartialFirst: '#page-num-',
      pageMobileSuffix: '-mobile',
      pageContentSuffix: '-content'
    },
    selectors: {
      instalmentTablePages: 'div[id^="page-instalments"]',
      instalmentTablePageNumbers: 'span[id^="page-num"]'
    },
    init: function init(options) {
      var _this = this;
      $.extend(_this.options, options);
      initInstalmentTableAndPageLists();
      _this.initEventListeners();
      function initInstalmentTableAndPageLists() {
        var base = $(_this.element).closest('.' + _this.classes.instalmentTables);
        _this.instalmentTable = {
          'tables': base.find(_this.selectors.instalmentTablePages),
          'pages': base.find(_this.selectors.instalmentTablePageNumbers)
        };
      }
    },
    initEventListeners: function initEventListeners() {
      var _this = this;
      $('[' + _this.attr.pageIndex + ']').on('click', function () {
        var pageNumber = $(this).attr(_this.attr.pageIndex);
        _this.onSetInstalmentTablePage(pageNumber);
      });
    },
    onSetInstalmentTablePage: function onSetInstalmentTablePage(pageNumber) {
      var _this = this;
      hideInstalmentTables();
      deactivateInstalmentTablePageNumbers();
      var mobile = $(_this.partialIds.pageInstalmentsFirstPartial + pageNumber + _this.partialIds.pageMobileSuffix);
      var content = $(_this.partialIds.pageInstalmentsFirstPartial + pageNumber + _this.partialIds.pageContentSuffix);
      var pageMobile = $(_this.partialIds.pageNumberPartialFirst + pageNumber + _this.partialIds.pageMobileSuffix);
      var pageContent = $(_this.partialIds.pageNumberPartialFirst + pageNumber + _this.partialIds.pageContentSuffix);
      mobile.toggleClass(_this.classes.instalmentTableHidden);
      content.toggleClass(_this.classes.instalmentTableHidden);
      pageMobile.toggleClass(_this.classes.instalmentTablePageNumberActive);
      pageContent.toggleClass(_this.classes.instalmentTablePageNumberActive);
      if ($(window).width() > 768) {
        content[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      } else {
        mobile[0].scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
      function hideInstalmentTables() {
        var hiddenClass = _this.classes.instalmentTableHidden;
        _this.instalmentTable['tables'].each(function () {
          var table = $(this);
          if (!table.hasClass(hiddenClass)) {
            table.toggleClass(hiddenClass);
          }
        });
      }
      function deactivateInstalmentTablePageNumbers() {
        var activePageClass = _this.classes.instalmentTablePageNumberActive;
        _this.instalmentTable['pages'].each(function () {
          var page = $(this);
          if (page.hasClass(activePageClass)) {
            page.toggleClass(activePageClass);
          }
        });
      }
    }
  };
  $.fn.app_instalmentNavigator = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof InstalmentNavigator) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new InstalmentNavigator(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);